import { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

export default class SearchInput extends Component {
  constructor() {
    super();
    this.state = {
      searchQuery: "",
    };
  }

  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  render() {
    return (
      <div style={styles.searchContainer}>
        <FontAwesomeIcon icon={faSearch} style={styles.searchIcon} />
        <input
          type="text"
          placeholder="بحث ..."
          value={this.state.searchQuery}
          onChange={this.handleSearchChange}
          style={styles.searchInput}
        />
      </div>
    );
  }
}

const styles = {
  searchContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "300px", // Adjust the width as needed
  },
  searchIcon: {
    position: "absolute",
    left: "10px",
    color: "#aaa", // Icon color
  },
  searchInput: {
    width: "100%",
    padding: "10px 10px 10px 40px", // Adjust padding to make space for the icon
    borderRadius: "5px", // Rounded corners
    border: "1px solid #ccc", // Border color
    fontSize: "13px", // Font size
    outline: "none", // Remove the default outline
  },
};
